import React from 'react';
import { ListItem, ListItemAvatar, Avatar, ListItemText, Divider } from '@material-ui/core';
import { Reais } from '../../components/numberUtils';
import { Venda } from '../../models/venda';
import { KPIComparativo } from '../dashboard/KPIComparativo';

export interface ListItemVendedorProps {
  vendaPorVendedor: Venda;
  comparativo?: Venda;
}

export const ListItemVendedor = (props: ListItemVendedorProps) => {
  return <div key={props.vendaPorVendedor.codigo}>
    <ListItem>
      <ListItemAvatar>
        <Avatar variant="rounded" style={{ backgroundColor: 'orange' }}>
          {props.vendaPorVendedor.codigo}
        </Avatar>
      </ListItemAvatar>
      <ListItemText secondary={<span>{props.vendaPorVendedor.nome} </span>}>
        <span> {props.vendaPorVendedor.contagem} venda(s) </span>
      </ListItemText>
      <ListItemText style={{ textAlign: 'right' }} secondary={props.comparativo ? <KPIComparativo valorBase={props.vendaPorVendedor.totalLiquido!} valor={props.comparativo.totalLiquido!} /> : undefined}>
        <b style={{ fontSize: '1.1rem' }}><Reais valor={props.vendaPorVendedor.totalLiquido} />  </b>
      </ListItemText>
    </ListItem>
    <Divider />
  </div>;
};
